module.exports = __webpack_public_path__ + "static/media/Fitness Tracker.67f7561f.jpg";